import { useState } from 'react';
import { MinusIcon, PlusIcon } from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';

function InfoBubble({ description, title }) {
    const [expanded, setExpanded] = useState(true);
    const handleToggleClick = () => {
        setExpanded(!expanded);
    };

    return (
        <div className="flex w-full justify-center pb-10">
            <div className="[@media(min-width:350px)]:w-350px mx-10 w-full max-w-[350px] rounded-[10px] bg-white p-10 shadow-base">
                <div className="flex flex-row justify-between">
                    <p className="text-body-mobile-lg">{title}</p>
                    <div>
                        {expanded ? (
                            <MinusIcon
                                data-testid="minus-icon"
                                onClick={handleToggleClick}
                                className="h-[24px] w-[24px] hover:cursor-pointer"
                            />
                        ) : (
                            <PlusIcon
                                data-testid="plus-icon"
                                onClick={handleToggleClick}
                                className="h-[24px] w-[24px] hover:cursor-pointer"
                            />
                        )}
                    </div>
                </div>
                {expanded && <p className="mt-5 text-body-mobile-md">{description}</p>}
            </div>
        </div>
    );
}

InfoBubble.propTypes = {
    description: PropTypes.node.isRequired,
    title: PropTypes.node.isRequired,
};

export default InfoBubble;
